export default __webpack_public_path__ + "static/logo-cfbd799a6be03c4d1c4317a1e3e30123.png";